"use client"

import { Toaster as SileoToaster } from "sileo"

export function Toaster() {
  return <SileoToaster position="top-center" theme="light" />
}